import React from "react";
import "../assests/CSS/FeaturesHero.css";
import { heroData } from "./data";

const FeaturesHero = () => {
    return (
        <section
            className="herofeature-container  herofeature-bg"
            style={{ backgroundImage: `url(${heroData.backgroundImage})` }}
        >
            <div className="herofeature-overlay">
                <h2 className="herofeature-title">{heroData.title}</h2>
                <h3 className="herofeature-subtitle">{heroData.subtitle}</h3>
                <p className="herofeature-text">
                    At <span style={{ color: "#113157", fontWeight: "bold" }}>Thhiya</span><span style={{ color: "red", fontSize: "1.5rem", paddingRight:"0.5rem"}}>.</span> 
                    
                    {heroData.description}
                </p>

            </div>
        </section>
    );
};
export default FeaturesHero;
